import Editor from './components/Editor';

import './styles/App.scss';

function App() {
  return (
    <div className="App">
      <Editor />
    </div>
  );
}

export default App;
